import { EGiftVenue } from "./EGiftVenue.model";

export class EGiftPromoCode {
	guid: string;
	venueKey: number;
	promoCode: string;
	value: number;
	minimumValue: number;
	active: boolean;
	menuItemKey: number;
	used: number;
	discountMenuKey: number;

	menuItemName: string;
	discountMenuItemName: string;

	EGiftVenue: EGiftVenue;

	public constructor(init?: Partial<EGiftPromoCode>) {
		Object.assign(this, init);
	}
}
